import * as t from "io-ts";
import { PreferenceOption } from "./PreferenceOption";

export const CommPreferences = t.partial({
  pre_job: PreferenceOption,
  post_job: PreferenceOption,
  other: PreferenceOption,
});

export interface CommPreferences {
  pre_job?: PreferenceOption;
  post_job?: PreferenceOption;
  other?: PreferenceOption;
}
